<template>
    <Toast
        :group="PLACEMENT_WARNING_TOAST_GROUP"
        position="bottom-center"
        :pt="{
            root: {
                class: 'tw:w-max tw:max-w-[min(calc(100vw-2rem),40rem)] tw:max-h-[50vh] tw:overflow-y-auto tw:overscroll-contain tw:has-[.p-toast-message]:p-2',
            },
            message: { class: 'tw:shadow-lg tw:min-w-0 tw:rounded-3xl' },
            messageContent: { class: 'tw:flex tw:items-center' },
            buttonContainer: { class: 'tw:hidden' },
        }"
    >
        <template #message="slotProps">
            <div class="tw:flex tw:items-center tw:gap-3 tw:px-6 tw:py-3 tw:rounded-md">
                <div v-if="slotProps.message.detail" class="tw:text-sm tw:font-medium">
                    {{ slotProps.message.detail }}
                </div>
            </div>
        </template>
    </Toast>
</template>

<script setup>
import Toast from 'primevue/toast';

import { PLACEMENT_WARNING_TOAST_GROUP } from '@/components/attendance/attend-schedule/placementCoverageWarning.js';
</script>
